<template>
  <div class="d-flex flex-column">
    <sf-text class="text-justify">
      {{ text }}
    </sf-text>
    <login-link />
  </div>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import LoginLink from '@/modules/authentication/components/LoginLink.vue'

defineProps({
  text: {
    type: String,
    required: true
  }
})
</script>
